import type { ButtonsGroupProps } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { FC, useCallback, useMemo } from 'react';
import { booleanToYesNo, YES_NO_AVAILABLE_VALUES, YesNo } from 'utils/boolean';

type YesNoRadioButtonsProps = Omit<
  ButtonsGroupProps<YesNo>,
  'items' | 'selectedItems' | 'onSelect' | 'translationPrefix' | 'isRadio'
> & {
  value: boolean | null;
  onSelect(value: boolean): void;
  translationPrefix?: string;
};

export const YesNoRadioButtons: FC<YesNoRadioButtonsProps> = ({
  value,
  onSelect,
  translationPrefix,
  ...remainingProps
}) => {
  const yesNoValue = useMemo(() => booleanToYesNo(value), [value]);

  const onYesNoSelected = useCallback((value: YesNo) => onSelect(value === 'yes'), [onSelect]);

  return (
    <ButtonsGroup
      items={YES_NO_AVAILABLE_VALUES}
      selectedItems={yesNoValue}
      onSelect={items => onYesNoSelected(items[0])}
      isRadio
      translationPrefix={translationPrefix ?? 'boolean'}
      {...remainingProps}
    />
  );
};
